export const POLICIES_SESSION_KEY = 'restricted-policies-validated';
export const POLICIES_BADGE_KEY = 'restricted-policies-badge';
export const POLICIES_LASTNAME_KEY = 'restricted-policies-lastname';
export const BADGE_TOOLTIP_TEXT =
	'The badge number is located on the front of the SIDA badge, directly below the photo near the bottom. It appears as a black number printed above the red expiration date.';
